module.exports = __webpack_public_path__ + "img/img7.9a3ef2d4.svg";